/**
 * oid 流程 settle 信号：供 identityGate 在 lookup 前等待。
 * 空 settle 只结束当前等待；之后若写入真实 oneId，允许升级结论。
 */
import storageKeys from './storageKeys';
import { getCookie, getLocal } from './oneIDContext';

var OID_SETTLE_TIMEOUT_MS = 5000;

var settled = false;
var settledOid = '';
var waiters = [];
var timeoutId = null;

function text(value) {
  if (value == null) return '';
  var s = String(value).trim();
  if (!s || s === 'null' || s === 'undefined') return '';
  return s;
}

function readStoredOid() {
  return text(getCookie(storageKeys.CARTSEE_ONEID) || getLocal(storageKeys.CARTSEE_ONEID));
}

function flush(oid) {
  var list = waiters.slice();
  waiters = [];
  for (var i = 0; i < list.length; i++) {
    try {
      list[i](oid);
    } catch (e) { /* ignore */ }
  }
}

function clearTimer() {
  if (timeoutId == null) return;
  clearTimeout(timeoutId);
  timeoutId = null;
}

/**
 * oneID messageHandler / oneidInit 在结论已出时调用。
 * - 首次：结束等待（可为空）
 * - 已空 settle 后收到非空 oid：升级结论（不挡后到的真实 oneId）
 * - 已有非空：忽略空回包，避免把真实 oid 清掉
 */
export function notifyOidSettled(oid) {
  var next = text(oid);
  clearTimer();

  if (!settled) {
    settled = true;
    settledOid = next;
    flush(settledOid);
    return;
  }

  // 空 settle 粘住修复：后到的真实 oneId 可以升级
  if (!settledOid && next) {
    settledOid = next;
  }
}

function armTimeout() {
  if (settled || timeoutId != null) return;
  timeoutId = setTimeout(function () {
    timeoutId = null;
    notifyOidSettled('');
  }, OID_SETTLE_TIMEOUT_MS);
}

/**
 * 门禁 lookup 前等待 oid settle。
 * 优先读既有 cookie/local；已空 settle 时仍会再读一次 storage，避免错过晚到的 oneId。
 * @returns {Promise<string>}
 */
export function whenOidSettled() {
  var existing = readStoredOid();
  if (existing) {
    notifyOidSettled(existing);
    return Promise.resolve(existing);
  }
  if (settled) {
    return Promise.resolve(settledOid);
  }
  armTimeout();
  return new Promise(function (resolve) {
    existing = readStoredOid();
    if (existing) {
      notifyOidSettled(existing);
      resolve(existing);
      return;
    }
    if (settled) {
      resolve(settledOid);
      return;
    }
    waiters.push(resolve);
  });
}
